import { warn } from "@swivl-mono/helpers";
import { BrainType, CLUBrainInterface, InheritanceStatus, NLPBrainActionType, NLPBrainInterface, isNLPBrain } from "@swivl-mono/types";
import { SelectableOption } from "@swivl-mono/ui";
import _ from "lodash";
import * as React from "react";

import { PageLoadingView } from "../../App/Layout/Loading/LoadingView";
import { BrainsModel } from "../../Models/Brains/Brains.Model";
import NLPModel from "../../Models/NLP/NLP.Model";
import { QuestsModel } from "../../Models/Quests/Quests.Model";
import "./BrainsView.scss";
import { BrainsViewIntent } from "./Intent/BrainsViewIntent";

interface Props {
  brain: CLUBrainInterface;
}
export default function CLUBrainsView(props: Props) {
  const { brains } = BrainsModel.useState((state) => state);

  const { brain } = props;
  const { caches, cachesMap } = NLPModel.useState((state) => state);

  React.useEffect(() => {
    NLPModel.loadCaches(false);
    QuestsModel.loadQuestsList(false);
    BrainsModel.load(false);
  }, []);

  const cluCaches = React.useMemo(() => {
    if (!caches) return [];
    return caches.filter((c) => c.modelType === BrainType.CLU);
  }, [caches]);

  const handleCacheChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const selectedProjectName = e.target.value;
    if (!selectedProjectName || selectedProjectName === brain.model.projectName) return;
    const selectedCache = cluCaches.find((c) => c.appId === selectedProjectName);
    if (!selectedCache) return;
    brain.model.projectName = selectedCache.appId;
    brain.model.deploymentName = selectedCache.version;
    BrainsModel.updateBrain(brain, true);
  };

  const cacheKey = `${brain.model.projectName}`;
  const nlpCache = brain && cachesMap ? cachesMap[cacheKey] : null;

  if (!brain) {
    warn("No brain", brain);
    return <PageLoadingView navBarTitle=" " pageTitle=" " />;
  }

  if (!nlpCache) {
    warn("No cache found for", cacheKey);
    return (
      <div className="BrainsView NLPBrainsView">
        <label>Model Cache</label>
        <select value={brain.model.projectName} onChange={handleCacheChange}>
          <option value={brain.model.projectName}>{brain.model.projectName} (not found)</option>
          {cluCaches
            .filter((c) => c.appId !== brain.model.projectName)
            .map((cache) => (
              <option key={cache.id} value={cache.appId}>
                {cache.name || cache.appId}
              </option>
            ))}
        </select>
      </div>
    );
  }

  nlpCache.intents.forEach((intent) => {
    if (!brain.data.actions[intent.name]) {
      brain.data.actions[intent.name] = {
        type: NLPBrainActionType.QUEST,
        intent: intent.name,
        active: false,
        goto: ""
      };
    }
  });
  const actionsArray = Object.values(brain.data.actions).sort((a: any, b: any) => {
    if (a.intent < b.intent) {
      return -1;
    }
    if (a.intent > b.intent) {
      return 1;
    }
    return 0;
  });

  const isParent = brain.inheritance === InheritanceStatus.IS_PARENT;

  const brainItems: SelectableOption[] = [
    {
      label: "Brains",
      isHeading: true
    }
  ];
  brains?.forEach((brainToAdd) => {
    if (brainToAdd.slug === brain.slug) {
      return;
    }
    brainItems.push({ label: brainToAdd.name, value: "brain_" + brainToAdd.slug, data: { isBrain: true } });
  });

  return (
    <div className="BrainsView NLPBrainsView">
      <label>Model Cache</label>
      <select value={brain.model.projectName} onChange={handleCacheChange}>
        {cluCaches.map((cache) => (
          <option key={cache.id} value={cache.appId}>
            {cache.name || cache.appId}
          </option>
        ))}
      </select>
      <hr />
      <label>Default Unhandled</label>
      <BrainsViewIntent brain={brain} action={brain.data.unhandled} isParent={isParent} isDefault={true} brainItems={brainItems} />
      <hr />
      <label>Intents</label>
      {actionsArray.map((action) => {
        return <BrainsViewIntent key={action.intent} brain={brain} action={action} isParent={isParent} brainItems={brainItems} />;
      })}
    </div>
  );
}
